import { useState, type ChangeEventHandler } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface PasswordInputProps {
  id: string;
  label: string;
  autoComplete: string;
  value: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
  required?: boolean;
}

export function PasswordInput({
  id,
  label,
  autoComplete,
  value,
  onChange,
  required = false,
}: PasswordInputProps) {
  const [isVisible, setIsVisible] = useState(false);
  const visibilityLabel = `${isVisible ? 'Hide' : 'Show'} ${label.toLowerCase()}`;
  const Icon = isVisible ? EyeOff : Eye;

  return (
    <div>
      <label htmlFor={id} className="block text-sm font-medium text-foreground">
        {label}
      </label>
      <div className="relative mt-1">
        <input
          id={id}
          type={isVisible ? 'text' : 'password'}
          autoComplete={autoComplete}
          required={required}
          value={value}
          onChange={onChange}
          className="block w-full rounded-xl border border-input bg-background px-3 py-2 pr-12 text-sm shadow-sm focus:border-primary focus:outline-none focus:ring-1 focus:ring-ring"
        />
        <Button
          type="button"
          variant="ghost"
          size="icon"
          aria-label={visibilityLabel}
          aria-pressed={isVisible}
          title={visibilityLabel}
          onClick={() => setIsVisible((current) => !current)}
          className="absolute right-1.5 top-1/2 h-8 w-8 -translate-y-1/2 rounded-lg text-muted-foreground hover:text-foreground"
        >
          <Icon aria-hidden="true" />
        </Button>
      </div>
    </div>
  );
}
